var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-table" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.tableData, function (item) {
        return _c("div", { staticClass: "custom-table-item" }, [
          _c("div", [_vm._v(_vm._s(item.label))]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(item.weight) + "%")]),
          _vm._v(" "),
          _c("div", [
            _c("span", [_vm._v(_vm._s(item.limit))]),
            _vm._v("\n            单\n            "),
            _vm._v(" "),
            item.isExceed
              ? _c("span", {
                  staticClass: "el-icon-top",
                  staticStyle: { color: "red" },
                })
              : _vm._e(),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "custom-table-header" }, [
      _c("div", [_vm._v("模型")]),
      _vm._v(" "),
      _c("div", [_vm._v("比例")]),
      _vm._v(" "),
      _c("div", [_vm._v("订单上限")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }